var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerRestaurantSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22,
    fill: "white",
    stroke: "#FFBA00",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2948 18.2949C32.6843 18.6843 32.6843 19.3157 32.2948 19.7052L21.7071 30.2929C21.3166 30.6834 20.6834 30.6834 20.2929 30.2929L16.2054 26.2055C15.8158 25.8159 15.8158 25.1842 16.2054 24.7946C16.5947 24.4053 17.2257 24.4049 17.6154 24.7937L20.2932 27.465C20.6838 27.8546 21.316 27.8543 21.7062 27.4645L30.8848 18.2945C31.2743 17.9054 31.9055 17.9055 32.2948 18.2949Z",
    fill: "#080808"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerRestaurantSelected);
export default __webpack_public_path__ + "static/media/marker_restaurant_selected.e49777d3adcb95c89ef8dabe2eb0f0ef.svg";
export { ForwardRef as ReactComponent };